/**
 * Password Input Widget for RUL Forms
 */

import { Input } from 'antd';
import type { PasswordInputWidget } from '@/api/types/rul.types';

interface PasswordInputWidgetProps {
  widget: PasswordInputWidget;
  onChange: (name: string, value: any) => void;
  error?: string;
}

export const PasswordInputWidgetComponent: React.FC<
  PasswordInputWidgetProps
> = ({ widget, onChange, error }) => {
  if (!widget.visible) return null;

  const InputComponent = widget.show_toggle ? Input.Password : Input;

  return (
    <div className="rul-field">
      {widget.label && (
        <label className="rul-field-label">
          {widget.label}
          {widget.required && <span className="rul-field-required">*</span>}
        </label>
      )}
      <InputComponent
        name={widget.name}
        value={widget.value || ''}
        placeholder={widget.placeholder}
        disabled={!widget.enabled}
        status={error ? 'error' : undefined}
        onChange={(e) => onChange(widget.name, e.target.value)}
      />
      {widget.help_text && !error && (
        <div className="rul-field-help">{widget.help_text}</div>
      )}
      {error && <div className="rul-field-error">{error}</div>}
    </div>
  );
};
